import React, { useState, useEffect } from 'react';
import "./trafficareas.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import trafficareas1 from "../../../Assets/traffic-areas.jpg";
import { Link } from 'react-router';
import trafficareas2 from "../../../Assets/sound-barrier-india.webp";
import trafficareas3 from "../../../Assets/traffic-areas/Our-solutions.png";
import trafficareas4 from "../../../Assets/sound-barrier-manufacturer.webp";
import trafficareas5 from "../../../Assets/traffic-areas/traffic-areas1.png";
import trafficareas6 from "../../../Assets/traffic-areas/traffic-areas-2.png";
import trafficareas7 from "../../../Assets/traffic-areas/traffic-areas-3.png";
import trafficareas8 from "../../../Assets/traffic-areas/traffic-areas-4.png";
import trafficareas9 from "../../../Assets/traffic-areas/traffic-areas-5.png";
import trafficareas10 from "../../../Assets/traffic-areas/traffic-areas-6.png";
import HNavbar from '../../../Components/Navbar/HNavbar';
import MFooter from '../../../Components/Main-Footer/MFooter';

function TrafficAreas() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const animatedElements = document.querySelectorAll('.traffic-header,.traffic-header1,.traffic-header2,.traffic-header3,.traffic-header4,.traffic-header5,.traffic-header6');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <>
        <HNavbar />
            <section id='traffic-areas' className='home-traffic'>
                <div className='container p-0'>
                    <Sidebar />
                    <div className='row main-traffic-areas'>
                        <div className='col-12 col-md-6 d-flex justify-content-center align-items-center p-3'>
                            <div className='image-wrapper'>
                                <img className='img-fluid traffic-areas-home-img' src={trafficareas1} alt="traffic-areas" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-start text-white'>
                            <h1 className='traffic-header'>Traffic Area Noise Control Solutions | Sound Barrier</h1>
                            <p className='white-para'>Heavy traffic areas generate continuous noise from vehicles, buses, trucks, and road construction activities. This noise can disturb nearby shops, offices, and residential buildings. Sound Barrier Manufacture provides effective traffic area noise control solutions using high-performance sound barrier blankets and outdoor acoustic barriers.</p>
                            <p className='white-para'>Our traffic sound barrier systems are designed to reduce noise levels and protect surrounding commercial areas from disturbance.</p>
                            <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                        </div>
                    </div>
                </div>
            </section >

            <section id='traffic-areas'>
                <div className='container noice-control mt-4'>
                    <h1 className='traffic-header1'>Why Noise Control is Important in Traffic Areas</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={trafficareas2} alt="traffic-areas" style={{ height: "500px" }} />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Roadside commercial zones and shop areas are highly sensitive to continuous traffic noise. Excessive noise can cause:</p>
                            <ul className='list'>
                                <li>Disturbance to shop owners and customers</li>
                                <li>Reduced business productivity</li>
                                <li>Communication difficulties</li>
                                <li>Public complaints</li>
                                <li>Environmental noise regulation issues</li>
                            </ul>
                        </div>
                    </div>
                    <p>Installing proper outdoor sound barriers helps maintain a comfortable commercial environment.</p>

                    <h1 className='traffic-header2' style={{ marginTop: "10px" }}>Our Traffic Noise Barrier Solutions</h1>
                    <p>Sound Barrier Manufacture supplies durable and weather-resistant sound barrier systems suitable for high-traffic environments.</p>
                    <div className='row mt-5'>
                        <div className='col-sm-12 col-md-6'>
                            <h5>Key Features:</h5>
                            <ul className='list'>
                                <li>High STC-rated sound barrier material</li>
                                <li>Weather-resistant and UV-protected outer layer</li>
                                <li>Suitable for outdoor roadside installation</li>
                                <li>Easy mounting on fencing and metal structures</li>
                                <li>Fire-retardant options available</li>
                                <li>Reusable and long-lasting material</li>
                            </ul>
                            <p>Our traffic noise barriers are designed for temporary and semi-permanent installations.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={trafficareas3} alt="traffic-areas" style={{ height: "400px" }} />
                        </div>
                    </div>

                    <h1 className='traffic-header3' style={{ marginTop: "30px" }}>Benefits of Traffic Sound Barriers</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <img className='img-fluid' src={trafficareas4} alt="traffic-areas" />
                        </div>
                        <div className='col-sm-12 col-md-6 d-flex flex-column align-items-start justify-content-center'>
                            <p>Using traffic noise control systems helps:</p>
                            <ul className='list'>
                                <li>Reduce roadside noise pollution</li>
                                <li>Protect nearby shops and businesses</li>
                                <li>Improve customer comfort</li>
                                <li>Maintain regulatory compliance</li>
                                <li>Enhance urban environmental quality</li>
                            </ul>
                        </div>
                    </div>
                    <h1 className='traffic-header4' style={{ marginTop: "20px" }}>Applications in Traffic Areas</h1>
                    <h4 className='sub-title mt-3'>Our sound barrier solutions are suitable for:</h4>
                    <div className='row'>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas5} alt="Roadside commercial shops" />
                            <p>Roadside commercial shops</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas6} alt="Highway construction zones" />
                            <p>Highway construction zones</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas7} alt="Metro and flyover projects" />
                            <p>Metro and flyover projects</p>
                        </div>
                        <div className='col-sm-3 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas8} alt="Urban traffic junctions" />
                            <p>Urban traffic junctions</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas9} alt="Toll plazas" />
                            <p>Toll plazas</p>
                        </div>
                        <div className='col-sm-4 d-flex flex-column justify-content-center align-items-center'>
                            <img className='img-fluid app-circle-img' src={trafficareas10} alt="Temporary road work areas" />
                            <p>Temporary road work areas</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='traffic-areas' className='call'>
                <div className='container'>
                    <h1 className='traffic-header5'>Why Choose Us?</h1>

                    <ul className='traffic-list white-para'>
                        <li>Experienced outdoor noise control provider</li>
                        <li>High-performance traffic sound barrier systems</li>
                        <li>Custom size and thickness options</li>
                        <li>Quick supply and installation support</li>
                        <li>Cost-effective outdoor noise control solutions</li>
                    </ul>
                    <p className='white-para'>We provide reliable sound barrier systems designed to minimize shop disturbance and improve public comfort in busy traffic zones.</p>

                    <h1 className='traffic-header6'>Contact Us for Traffic Area Noise Control Solutions</h1>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6'>
                            <p className='white-para'>Looking for effective traffic noise control solutions?</p>
                            <p className='white-para'>Sound Barrier Manufacture delivers customized sound barrier systems to reduce roadside noise and protect surrounding commercial areas.</p>
                            <p className='white-para'>Contact us today for expert consultation and site-specific traffic noise control solutions.</p>
                        </div>
                        <div className='col-sm-12 col-md-6'>
                            <div className="row">
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        className="form-control"
                                        placeholder="Name *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="email"
                                        name="mail"
                                        id="mail"
                                        className="form-control"
                                        placeholder="Email *"
                                    />
                                </div>
                                <div className="col-sm-12 col-md-4 mb-3">
                                    <input
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        className="form-control"
                                        placeholder="Phone *"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <textarea
                                        rows={4}
                                        id="message"
                                        className="form-control"
                                        placeholder="Message *"
                                    ></textarea>
                                </div>
                                <div className="col-12">
                                    <button
                                        className="btn"
                                        type="button"
                                        onClick={handleClick}
                                    >
                                        SEND
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
            <MFooter />
        </>
    )
}


export default TrafficAreas